import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=bbb8ef96&scoped=true&"
import script from "./Dashboard.vue?vue&type=script&lang=js&"
export * from "./Dashboard.vue?vue&type=script&lang=js&"
import style0 from "./Dashboard.vue?vue&type=style&index=0&id=bbb8ef96&prod&scoped=true&lang=css&"
import style1 from "./Dashboard.vue?vue&type=style&index=1&id=bbb8ef96&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbb8ef96",
  null
  
)

export default component.exports